import { render, staticRenderFns } from "./bxtongji.vue?vue&type=template&id=3de22f85&scoped=true"
import script from "./bxtongji.vue?vue&type=script&lang=js"
export * from "./bxtongji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de22f85",
  null
  
)

export default component.exports